import {
  ThemedFunctor, BreakpointQueryName,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const content: ThemedFunctor = ({ theme }) => css`
  padding: 0 ${theme.remSize[300]} ${theme.remSize[300]};
  margin: 0 -${theme.remSize[300]} ${theme.remSize[300]};
  background-color: ${theme.palettes.neutrals.lightest};

  &:last-child {
    margin-bottom: 0;
  }

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    margin: 0 0 ${theme.remSize[200]};
    border: 1px solid ${theme.color.border.neutral.default.low};
    padding: ${theme.remSize[300]};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
